import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService extends BaseProvider {
	paymentFormIsVisible: any = false;
	paymentPlanFormIsVisible: any = false;
	paymentPlanInfoIsVisible: any = false;
	invoiceToPayId: any = 0;
	invoice: any;
	toggleDateFormatError:boolean = false;

	
  	constructor(
		public globals: GlobalsService,
 		public http: HttpClient,	
 		public ls: LsHelperService,
  	) { 
		super();

		this.baseUrl = "invoice";		
	}	

	payAndSubmit(data, transactionId){
	    return new Promise( (resolve, reject) => {
	      this.url = this.globals.dataUrl + this.baseUrl + `/payment/${transactionId}`;

	        this.http
	        .post(
	          this.url,
	          data
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
	    });     		
	}
	
	payAndSubmitAch(data, transactionId){
	    return new Promise( (resolve, reject) => {
	      this.url = this.globals.dataUrl + this.baseUrl + `/payment/ach/${transactionId}`;

	        this.http
	        .post(
	          this.url,
	          data
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
	    });     		
	}

	pay(data, transactionId){
	    return new Promise( (resolve, reject) => {
	      this.url = this.globals.dataUrl + this.baseUrl + `/payment/new/${transactionId}`;

	        this.http
	        .post(
	          this.url,
	          data
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
	    });     		
	}	

	getFees(processTypeId){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + `processType/config/${processTypeId}`;

			this.http
			.get(this.url)
			.subscribe(
			    (data: any) => {
					resolve(data.Data);
			    },
			    err => {reject(err)}
			);
		});    		
	}	

	getCosts(invoiceId){	
	    return new Promise( (resolve, reject) => {
	      this.url = this.globals.dataUrl + this.baseUrl + `/payment/costs/${invoiceId}`;

	        this.http
	        .get(
	          this.url
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
	    });     		
	}		
}
